import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      it: {
        global: {
          send: 'Registrati',
          Register_Title: 'Attivazione profilo unico',
          Password_Char: 'Deve contenere tra 8 e 29 caratteri',
          Password_Upper_Lower: 'Almeno una lettera minuscola o maiuscola',
          Password_Number: 'Deve contenere almeno un numero (0-9)',
          Password_Special_Char: 'Deve utilizzare un carattere speciale',
          Password_equality: 'Le password devono essere le stesse',
          Password_Placeholder: 'Password',
          Confirm_Password_Placeholder: 'Conferma password',
          Register_Success: 'Registrazione completata con successo',
          Register_Failed: 'Si è verificato un errore. Per favore riprova.',
          Change_Password_Title: 'Cambiare la password',
          Set_Password_Title: 'Imposta la tua password',
          Set_Password_Text: 'Inserisci l\'indirizzo email associato al tuo Juicebox.',
          Confirm_Button: 'Confermare',
          Create_Password_Button: 'Crea password',
          Try_Again_Button: 'Riprova',
          Email_placeholder: 'name@mail.com',
          Reset_Pw_Error_Title: 'Si è verificato un errore',
          Reset_Pw_Error_Message: 'La password non è stata modificata. Per favore prova più tardi.',
          Error_Title_Wrong_Email: 'C\'è stato un errore. La password non è stata modificata',
          Error_Message_Wrong_Email: 'Questa non è l\'e-mail associata al tuo JuiceBox. Per favore riprova',
          Password_Changed_Title: 'La password è stata cambiata',
          Password_Changed_Text: 'La password è stata modificata con successo. Puoi usare una nuova password quando accedi la prossima volta.',
          Password_Changed_Text_USA: 'La password è stata modificata con successo. Ora puoi scaricare e accedere all\'app EXW.',
          OTP_Code_Title: 'Inserisci il codice OTP e la nuova password',
          OTP_Code_Text: 'Il codice OTP è una password temporanea che ti abbiamo inviato via email.',
          New_Password: 'Nuova password',
          fiscal_code_placeholder: 'es. MRARSS80A01H501T',
          Confirm_Password: 'Conferma password',
          Error_Empty_Field: 'Si prega di compilare il campo e-mail!',
          Error_Empty_Fields: 'Si prega di compilare tutti i campi!',
          Toast_Pass_Mismatch: 'Le password devono essere le stesse',
          Toast_Pass_Incorrect: 'Formato password errato',
          Invalid_Validation_Code: 'Codice di validazione già utilizzato o non valido',
          Terms_And_Privacy_Text: `Dichiaro di aver letto e di accettare ${'\n'} `,
          And_Text: ' e',
          Terms_Text: 'i termini e le condizioni',
          Privacy_Text: `${'\n'}politica sulla riservatezza`,
          Service_Text: ' del servizio',
          Confirm_Activation_SplitHome: 'Conferma l\'attivazione dell\'offerta SplitHome.',
          Fiscal_code: 'Codice Fiscale',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
      es: {
        global: {
          send: 'Registrarse',
          Register_Title: 'Activación unica de perfil',
          Password_Char: 'Debe tener entre 8 y 29 Caracteres',
          Password_Upper_Lower: 'Debe tener al menos una letra minúscula o mayúscula',
          Password_Number: 'Debe contener al menos un número',
          Password_Special_Char: 'Debe contener al menos un caracter especial',
          Password_equality: 'Las contraseñas deben ser iguales',
          Password_Placeholder: 'Contraseña',
          Confirm_Password_Placeholder: 'Confirme contraseña',
          Register_Success: 'Registro completado con éxito',
          Register_Failed: 'Ha ocurrido un error. Por favor intentelo nuevamente',
          Change_Password_Title: 'Cambio de contraseña',
          Set_Password_Title: 'Establece tu contraseña',
          Set_Password_Text: 'Ingrese la dirección de correo electrónico asociada con su Juicebox.',
          Confirm_Button: 'Confirmar',
          Create_Password_Button: 'Crear contraseña',
          Try_Again_Button: 'Intentar otra vez',
          Email_placeholder: 'name@mail.com',
          Reset_Pw_Error_Title: 'Ha ocurrido un error',
          Reset_Pw_Error_Message: 'La contraseña no ha sido cambiada. Por favor intente mas tarde.',
          Error_Title_Wrong_Email: 'Se ha producido un error. La contraseña no ha sido cambiada',
          Error_Message_Wrong_Email: 'Este no es el correo electrónico asociado con su JuiceBox. Inténtalo de nuevo',
          Password_Changed_Title: 'Contraseña cambiada',
          Password_Changed_Text: 'La contraseña ha sido cambiada con éxito. Puede usar una nueva contraseña cuando acceda la próxima vez.',
          Password_Changed_Text_USA: 'La contraseña ha sido cambiada con éxito. Ahora puede descargar e iniciar sesión en la aplicación EXW.',
          OTP_Code_Title: 'Inserte el código OTP y la nueva contraseña',
          OTP_Code_Text: 'El código OTP es una contraseña temporal que le enviamos por correo electrónico.',
          New_Password: 'Nueva contraseña',
          Confirm_Password: 'Confirmar Contraseña',
          Error_Empty_Field: '¡Complete el campo de correo electrónico!',
          Error_Empty_Fields: '¡Por favor rellena todos los campos!',
          Toast_Pass_Mismatch: 'Asegurese de que las contraseñas sean iguales',
          Toast_Pass_Incorrect: 'Formato de contraseña incorrecto',
          Invalid_Validation_Code: 'Código de validación ya utilizado o no válido',
          Terms_And_Privacy_Text: `Declaro que he leído y acepto ${'\n'}las `,
          And_Text: ' y',
          Terms_Text: 'términos y condiciones',
          Privacy_Text: `${'\n'}política de privacidad`,
          Service_Text: ' del servicio',
          Confirm_Activation_SplitHome: 'Confirmar la activación de la oferta SplitHome.',
          Fiscal_code: 'Codigo Fiscal',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
      ca: {
        global: {
          send: 'Registrar-se',
          Register_Title: 'Activació del perfil únic',
          Password_Char: 'Manteniu-lo entre 8 i 29 caràcters',
          Password_Upper_Lower: 'Almenys una lletra minúscula o majúscula',
          Password_Number: 'Ha de contenir almenys un número (0-9)',
          Password_Special_Char: 'Ha d\'utilitzar un caràcter especial',
          Password_equality: 'Les contrasenyes han de ser iguals',
          Password_Placeholder: 'Contrasenya',
          Confirm_Password_Placeholder: 'Confirma la contrassenya',
          Register_Success: 'El registre s\'ha completat correctament',
          Register_Failed: 'Hi ha hagut un error. Siusplau torna-ho a provar.',
          Change_Password_Title: 'Canvi de contrasenya',
          Toast_Pass_Mismatch: 'Les contrasenyes han de ser iguals',
          Toast_Pass_Incorrect: 'Format incorrecte de la contrasenya',
          Invalid_Validation_Code: 'El codi de validació ja s\'ha utilitzat o no és vàlid',
          Confirm_Activation_SplitHome: 'Confirma l\'activació de l\'oferta de SplitHome.',
          Fiscal_code: 'Codi Fiscal',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
      de: {
        global: {
          send: 'Registrieren',
          Register_Title: 'Einzigartige Profilaktivierung',
          Password_Char: 'Halten Sie es zwischen 8 und 29 Zeichen',
          Password_Upper_Lower: 'Mindestens ein Klein- oder Großbuchstabe',
          Password_Number: 'Muss mindestens eine Zahl enthalten (0-9)',
          Password_Special_Char: 'Muss ein Sonderzeichen verwenden',
          Password_equality: 'Passwörter müssen gleich sein',
          Password_Placeholder: 'Passwort',
          Confirm_Password_Placeholder: 'Passwort bestätigen',
          Register_Success: 'Registrierung erfolgreich abgeschlossen',
          Register_Failed: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
          Change_Password_Title: 'Passwortänderung',
          Toast_Pass_Mismatch: 'Passwörter müssen gleich sein',
          Toast_Pass_Incorrect: 'Falsches Format der Gegensätze',
          Invalid_Validation_Code: 'Validierungscode bereits verwendet oder ungültig',
          Confirm_Activation_SplitHome: 'Bestätigen Sie die Aktivierung des SplitHome Angebots.',
          Fiscal_code: 'Steuergesetzbuch',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
      ro: {
        global: {
          send: 'Inregistreaza-te',
          Register_Title: 'Activare unică a profilului',
          Password_Char: 'Păstrați-l între 8 și 29 de caractere',
          Password_Upper_Lower: 'Cel puțin o literă mică sau mare',
          Password_Number: 'Trebuie să conțină cel puțin un număr (0-9)',
          Password_Special_Char: 'Trebuie să folosească un caracter special',
          Password_equality: 'Parolele trebuie să fie egale',
          Password_Placeholder: 'Parola',
          Confirm_Password_Placeholder: 'Confirmă parola',
          Register_Success: 'Înregistrarea a fost finalizată cu succes',
          Register_Failed: 'A aparut o eroare. Vă rugăm să încercați din nou.',
          Change_Password_Title: 'Schimbarea parolei',
          Toast_Pass_Mismatch: 'Parolele trebuie să fie egale',
          Toast_Pass_Incorrect: 'Formatare incorectă a parolei',
          Invalid_Validation_Code: 'Cod de validare deja folosit sau invalid',
          Confirm_Activation_SplitHome: 'Confirmarea activării ofertei SplitHome.',
          Fiscal_code: 'Cod Fiscal',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
      en: {
        global: {
          Send: 'Register',
          Register_Title: 'Unique profile activation',
          Password_Char: 'Keep it between 8 and 29 characters',
          Password_Upper_Lower: 'At least a lower case or upper case letter',
          Password_Number: 'Must contain at least one number (0-9)',
          Password_Special_Char: 'Must use one special character',
          Password_equality: 'Passwords must be equal',
          Password_Placeholder: 'Password',
          Confirm_Password_Placeholder: 'Confirm Password',
          Register_Success: 'Registration completed successfully',
          Register_Failed: 'An error occurred. Please try again.',
          Change_Password_Title: 'Password change',
          Set_Password_Title: 'Set your password',
          Set_Password_Text: 'Please enter the email address that is associated with your Juicebox.',
          Confirm_Button: 'Confirm',
          Confirm_Activation_SplitHome: 'Confirm activation of the SplitHome offer.',
          Create_Password_Button: 'Create password',
          Send_Confirmation: 'Send confirmation',
          Try_Again_Button: 'Try again',
          Email_placeholder: 'name@mail.com',
          Reset_Pw_Error_Title: 'An error has occurred',
          Reset_Pw_Error_Message: 'Password has not been changed. Please try later.',
          Error_Title_Wrong_Email: 'An error has occurred. Password has not been changed',
          Error_Message_Wrong_Email: 'This is not the email that is associated with your JuiceBox. Please try again',
          Password_Changed_Title: 'Password changed',
          Password_Changed_Text: 'Password has been changed successfully. You can use new password when you access next time.',
          Password_Changed_Text_USA: 'Password has been changed successfully. You can now download and login to the EXW app.',
          OTP_Code_Title: 'Insert OTP code and new password',
          OTP_Code_Text: 'OTP code is a temporary password that we sent you via email.',
          New_Password: 'New password',
          Confirm_Password: 'Confirm password',
          Error_Empty_Field: 'Please fill in the email field!',
          Error_Empty_Fields: 'Please fill in all fields',
          Toast_Pass_Mismatch: 'Passwords must be equal',
          Toast_Pass_Incorrect: 'Incorrect password formatting',
          Invalid_Validation_Code: 'Validation code already used or invalid',
          Terms_And_Privacy_Text: `I declare that i have read and agree to${'\n'}the `,
          And_Text: ' and',
          Terms_Text: 'terms and conditions',
          Privacy_Text: `${'\n'}privacy policy`,
          Service_Text: ' of the service',
          POD: 'POD',
          fiscal_code_placeholder: 'es. MRARSS80A01H501T',
          Fiscal_code: 'Fiscal Code',
          pod_placeholder: 'es. IT001E14497857',
        },
      },
    },
    detection: {
      order: ['cookie', 'navigator', 'htmlTag', 'querystring'],
      caches: ['cookie'], // Si lo seteo en local lo puedo usar para enviarlo en el post!
    },
    fallbackLng: 'en',

    // have a common namespace used around the full app
    fallbackNS: 'global',
    defaultNS: 'global',
    debug: false, // activate when working on translations
    returnObjects: true, // used for component translations. it passes the whole translated object to the guicomlib
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
